import { useForm } from "react-hook-form";
import usePostHook from "../../customHooks/usePostHook";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";

const CreateFolder = ({ setOpenCreateFolderPopup, id = "" }) => {
  const {
    register,
    formState: { errors },
    setError,
    handleSubmit,
  } = useForm<any>({
    defaultValues: {
      title: "Untitle Folder",
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["folder"],
  });

  const handleCreateFolder = async (values: any, setError: any) => {
    const url = APIS.FOLDER;
    const formData = {
      ...values,
      ...(id
        ? {
            parent: id,
          }
        : {}),
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenCreateFolderPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };
  
  return (
    <div className={tw`w-72`}>
      <form
        onSubmit={handleSubmit((data) => handleCreateFolder(data, setError))}
      >
        <div>
          <TextField register={register("title")} errors={errors?.title} />
        </div>
        <div>
          <div className={tw`flex gap-x-4 items-center`}>
            <button
              type="button"
              onClick={() => setOpenCreateFolderPopup(false)}
              className={tw`bg-gray-400 w-full text-white py-2 rounded my-2 focus:outline-none`}
            >
              Cancel
            </button>
            <Button label={"Save"} isLoading={isPostLoading} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateFolder;
